import { ImageAlbumGallery } from "@idwal/idwal-react-components";
import { DocumentResponse } from "../../types/responses/documentResponse";
import { GetPhotosResponse } from "../../types/responses/GetPhotosResponse";
import { useParams } from "react-router-dom";
import React from "react";
import { AppContext } from "../../App";
import { AppContextType } from "../../types/AppContextType";

export const ImageAlbumGalleryComponent = (
    autoOpen: boolean,
    data: GetPhotosResponse[] | undefined,
    documentData: DocumentResponse | undefined,
    selectedArea?: string,
    classNames?: string,
    openButtonStyle?: "default" | "icon-only" | undefined
) => {
    const { inspectionId } = useParams();
    const { restrictedView } = React.useContext(AppContext) as AppContextType;

    if (!data) {
        return <></>;
    }

    const zipUrl = documentData?.zipElement?.value?.url ?? "";

    if (data.length === 0) {
        return <></>;
    }

    const defaultAlbum = data.filter((album) => album.isDefault)[0];
    data = data.filter((album) => !album.isDefault);

    return (
        <div className={classNames}>
            <ImageAlbumGallery
                autoOpen={autoOpen}
                zipUrl={zipUrl}
                albums={data}
                defaultAlbum={defaultAlbum}
                downloadDisabled={restrictedView}
                selectedAlbumKey={selectedArea}
                openButtonStyle={openButtonStyle}
                closeCallback={
                    autoOpen
                        ? () => {
                              location.href = "/inspection/" + inspectionId;
                          }
                        : undefined
                }
            />
        </div>
    );
};
